/**
 * @fileoverview Estilos da abordagem inteligente na conversa (faixa e
 * "Detalhes"), nos tons da triagem: neutros, com cor só no estado (verde o
 * cliente respondeu, vermelho erro). Anel de foco de 1px.
 */

import { makeStyles } from "@material-ui/core/styles";
import { tokens } from "../Triage/styles";

const useStyles = makeStyles((theme) => {
  const dark = theme.palette.type === "dark";
  const c = tokens(dark);
  const focus = { outline: `1px solid ${c.textPrimary}`, outlineOffset: 1 };
  const button = {
    height: 28,
    padding: "0 10px",
    borderRadius: 8,
    border: `1px solid ${c.inputBorder}`,
    background: "transparent",
    color: c.textPrimary,
    fontSize: 12.5,
    fontWeight: 500,
    fontFamily: "inherit",
    whiteSpace: "nowrap",
    cursor: "pointer",
    "&:hover:not(:disabled)": { background: c.hover },
    "&:disabled": { opacity: 0.55, cursor: "default" },
    "&:focus-visible": focus,
  };

  return {
    // Faixa
    bar: {
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      gap: "6px 10px",
      padding: "7px 12px",
      borderTop: `1px solid ${c.border}`,
      background: theme.palette.background.paper,
      color: c.textPrimary,
      fontSize: 13,
      lineHeight: 1.4,
    },
    icon: { display: "inline-flex", flexShrink: 0, color: c.textSecondary, "& svg": { width: 16, height: 16 } },
    text: { flex: "1 1 260px", minWidth: 0 },
    title: { fontWeight: 600 },
    detail: { color: c.textSecondary },
    // No celular a dica fica só nos Detalhes: a faixa não toma a conversa.
    hint: { display: "block", fontSize: 12, color: c.textMuted, [theme.breakpoints.down("xs")]: { display: "none" } },
    // Depois de icon e detail: a cor do estado vence a neutra.
    tone_ok: { color: c.ok },
    tone_bad: { color: c.bad },
    actions: { display: "flex", alignItems: "center", gap: 6, marginLeft: "auto" },
    btn: button,
    iconBtn: {
      ...button,
      width: 28,
      padding: 0,
      border: "none",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      color: c.textMuted,
      "&:hover:not(:disabled)": { background: c.hover, color: c.textPrimary },
      "& svg": { width: 16, height: 16 },
    },

    // Detalhes
    paper: {
      borderRadius: 18,
      background: c.surface,
      width: "100%",
      maxWidth: 460,
      margin: 16,
      boxShadow: dark
        ? "0 24px 48px -12px rgba(0,0,0,0.6), 0 0 0 1px rgba(255,255,255,0.06)"
        : "0 24px 48px -12px rgba(15,23,42,0.28), 0 0 0 1px rgba(15,23,42,0.04)",
    },
    header: { display: "flex", alignItems: "flex-start", gap: 12, padding: "20px 20px 0" },
    headerText: { flex: 1, minWidth: 0 },
    dialogTitle: { margin: 0, fontSize: 16, fontWeight: 600, color: c.textPrimary, lineHeight: 1.35 },
    subtitle: { fontSize: 12.5, color: c.textSecondary, marginTop: 2, wordBreak: "break-word" },
    close: {
      background: "transparent",
      border: "none",
      padding: 4,
      margin: "-4px -4px 0 0",
      cursor: "pointer",
      color: c.textMuted,
      display: "inline-flex",
      borderRadius: 8,
      "&:hover": { color: c.textPrimary, background: c.hover },
      "&:focus-visible": focus,
      "& svg": { width: 18, height: 18 },
    },
    body: { padding: "14px 20px 20px", display: "flex", flexDirection: "column", gap: 14 },
    summary: { fontSize: 13, color: c.textPrimary, lineHeight: 1.45 },
    stopDetail: { display: "block", fontSize: 12, color: c.textSecondary, marginTop: 2 },
    footnote: { fontSize: 12, color: c.textMuted, lineHeight: 1.45, margin: 0 },
    footer: { display: "flex", justifyContent: "flex-end", gap: 8, padding: "0 20px 20px" },
  };
});

export default useStyles;
